import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import { ColumnSelectionActionsProps } from '../types';

import type { JSX } from 'react';

export const ColumnSelectionActions = ({ provider, className }: ColumnSelectionActionsProps): JSX.Element => {
  const commonProps = {
    loading: provider.isSaving,
    color: 'secondary' as const,
    loadingPosition: 'start' as const,
    style: { minWidth: 'fit-content' },
    type: 'button' as const,
  };

  return (
    <Stack direction={'row'} spacing={2} minWidth={'11rem'} className={className}>
      <LoadingButton
        variant='outlined'
        onClick={provider.onReset}
        disabled={provider.isSaving || !provider.hasChanges}
        {...commonProps}
      >
        Reset
      </LoadingButton>
      <LoadingButton
        onClick={provider.onSave}
        disabled={provider.isSaving || !provider.hasChanges}
        variant='contained'
        {...commonProps}
      >
        Save Changes
      </LoadingButton>
    </Stack>
  );
};
